"use client"

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(function Checkbox({ className, ...props }, ref) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        // Base: 16×16px, 2px radius, neutral.10 border, transparent bg
        "peer size-4 shrink-0 rounded-[2px] border border-[var(--field-text-color)] bg-transparent text-[var(--field-text-color)] outline-none transition-[box-shadow] duration-200",
        // Checked: keep transparent bg + neutral.10 border (outline variant)
        "data-[state=checked]:bg-transparent data-[state=checked]:border-[var(--field-text-color)] data-[state=checked]:text-[var(--field-text-color)]",
        // Hover + focus: 1px halo brown.30
        "hover:shadow-[0_0_0_1px_var(--field-focus-color)] focus-visible:shadow-[0_0_0_1px_var(--field-focus-color)]",
        // Error: red.40 border
        "aria-invalid:border-[var(--field-error-color)] aria-invalid:shadow-none",
        // Use enabled:cursor-pointer so tw-merge does not drop disabled:cursor-not-allowed.
        "enabled:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 disabled:border-[var(--field-label-color)]",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})

export { Checkbox }
